import * as React from 'react';
import { CLASSNAME_PREFIX as cp } from '../componentConfig';
import './VerificationErrorPage.scss';
var VerificationErrorPage = function (_a) {
    var firstName = _a.firstName, custHelpLink = _a.custHelpLink, translate = _a.t;
    return (React.createElement("div", { className: "".concat(cp, "-verification-error") },
        React.createElement("div", { className: "".concat(cp, "-verification-error__icon") },
            React.createElement("div", null)),
        React.createElement("div", null,
            React.createElement("p", { className: "".concat(cp, "-verification-error__title") }, translate('VERIFICATION_ERROR_TITLE')),
            React.createElement("p", { className: "".concat(cp, "-verification-error__message") },
                translate('VERIFICATION_ERROR_MESSAGE_1'),
                firstName,
                ","),
            React.createElement("p", { className: "".concat(cp, "-verification-error__message") }, translate('VERIFICATION_ERROR_MESSAGE_2')),
            React.createElement("p", { className: "".concat(cp, "-verification-error__message") }, translate('VERIFICATION_ERROR_MESSAGE_3')),
            React.createElement("p", { className: "".concat(cp, "-verification-error__message") },
                translate('VERIFICATION_ERROR_MESSAGE_4'),
                ' ',
                React.createElement("a", { target: "_blank", href: custHelpLink },
                    translate('VERIFICATION_ERROR_LINK_MESSAGE'),
                    ' ')))));
};
export default VerificationErrorPage;
//# sourceMappingURL=VerificationErrorPage.js.map